const BRANDS = ['BMW','Audi','Mercedes AMG','Volkswagen','Skoda','SEAT','Ford','Vauxhall','Toyota','Honda','Lexus','Porsche','Ferrari','Lamborghini','Alfa Romeo','Peugeot','Renault','Hyundai','Kia'];
const BRAND_DISPLAY = ['BMW','AUDI','AMG','VW','RS','ŠKODA','SEAT','FORD','VAUXHALL','TOYOTA','HONDA','LEXUS','PORSCHE','FERRARI','LAMBO','ALFA','PEUGEOT','RENAULT','HYUNDAI','KIA'];

function brandToHandle(brand) {
  return brand.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
}

function brandUrl(brand) {
  return '/collections/' + brandToHandle(brand);
}

// ===== BRAND STRIP =====
function initBrandStrip() {
  const el = document.getElementById('stripTrack');
  if (!el) return;
  const all = [...BRAND_DISPLAY, ...BRAND_DISPLAY];
  el.innerHTML = all.map((b, i) =>
    `<a class="strip-item" href="${brandUrl(BRANDS[i % BRANDS.length])}"><span>${b}</span></a>`
  ).join('');
}

// ===== BRAND DROPDOWNS =====
function initBrandDropdowns() {
  const headerMenu = document.getElementById('brandsMenuHeader');
  if (headerMenu) {
    headerMenu.innerHTML = BRANDS.map(b =>
      `<a class="dropdown-item" href="${brandUrl(b)}">${b}<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg></a>`
    ).join('');
  }
  const mobileGrid = document.getElementById('mobileBrandsGrid');
  if (mobileGrid) {
    mobileGrid.innerHTML = BRANDS.map(b =>
      `<a class="mobile-brand-item" href="${brandUrl(b)}">${b}</a>`
    ).join('');
  }
  const brandPanel = document.getElementById('brandPanel');
  if (brandPanel) {
    brandPanel.innerHTML = BRANDS.map(b =>
      `<a class="brand-opt" href="${brandUrl(b)}">${b}<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg></a>`
    ).join('');
  }
}

// ===== HEADER DROPDOWN TOGGLE =====
function toggleHeaderBrands() {
  const panel = document.getElementById('brandsMenuHeader');
  const btn = document.getElementById('brandsBtnHeader');
  if (!panel || !btn) return;
  const open = panel.classList.contains('open');
  closeAllDropdowns();
  if (!open) { panel.classList.add('open'); btn.classList.add('open'); }
}

// ===== BRAND PANEL TOGGLE =====
function toggleBrandPanel() {
  const panel = document.getElementById('brandPanel');
  const btn = document.getElementById('brandToggle');
  if (!panel || !btn) return;
  const open = panel.classList.contains('open');
  closeAllDropdowns();
  if (!open) { panel.classList.add('open'); btn.classList.add('open'); }
}

// ===== FILTER MENUS =====
function toggleFilterMenu(type) {
  const menu = document.getElementById('filterMenu_' + type);
  if (!menu) return;
  const open = menu.classList.contains('open');
  closeAllDropdowns();
  if (!open) {
    menu.classList.add('open');
    const btn = document.getElementById('filterBtn_' + type);
    if (btn) btn.classList.add('open');
  }
}

function closeAllDropdowns() {
  document.querySelectorAll('.dropdown-panel, .brand-panel, .filter-menu').forEach(el => el.classList.remove('open'));
  document.querySelectorAll('.nav-dropdown-btn, .brand-toggle, .filter-btn').forEach(el => el.classList.remove('open'));
  const headerBtn = document.getElementById('brandsBtnHeader');
  if (headerBtn) headerBtn.classList.remove('open');
}

document.addEventListener('click', function(e) {
  if (!e.target.closest('.nav-dropdown') &&
      !e.target.closest('.brand-outer') &&
      !e.target.closest('.filter-drop')) {
    closeAllDropdowns();
  }
});

// ===== MOBILE MENU =====
function toggleMobileMenu() {
  const menu = document.getElementById('mobileMenu');
  if (!menu) return;
  menu.classList.toggle('open');
}

function toggleMobileBrands() {
  const grid = document.getElementById('mobileBrandsGrid');
  const btn = document.getElementById('mobileBrandsBtn');
  if (!grid || !btn) return;
  grid.classList.toggle('open');
  btn.classList.toggle('open');
}

// ===== CONTACT FORM =====
function submitContact(e) {
  e.preventDefault();
  const btn = document.getElementById('contactSubmitBtn');
  if (btn) {
    btn.innerHTML = `<svg style="width:15px;height:15px;stroke:currentColor;fill:none;stroke-width:2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg> Sent!`;
    btn.style.background = '#16a34a';
    setTimeout(() => {
      btn.innerHTML = `<svg style="width:15px;height:15px;stroke:currentColor;fill:none;stroke-width:2" viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg> Send Message`;
      btn.style.background = '';
    }, 3000);
  }
  e.target.reset();
}

// ===== TOAST =====
function showToast(msg, type) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.style.background = type === 'error' ? '#dc2626' : '#16a34a';
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 3000);
}

// ===== SWATCH SWITCHING =====
function switchSwatch(el, productId, imgUrl, price) {
  // Update active swatch
  const swatches = document.querySelectorAll(`#swatches-${productId} .swatch-dot`);
  swatches.forEach(s => s.classList.remove('active'));
  el.classList.add('active');
  // Update product image
  const card = el.closest('.product-card');
  if (card) {
    const img = card.querySelector('.product-img img');
    if (img && imgUrl && imgUrl !== 'null') img.src = imgUrl;
  }
  // Update price
  const priceEl = document.getElementById(`price-${productId}`);
  if (priceEl && price) priceEl.textContent = price;
}

// ===== INIT =====
document.addEventListener('DOMContentLoaded', function() {
  initBrandStrip();
  initBrandDropdowns();
});
